import { useEffect, useState } from 'react';
import { Tag } from 'antd';
import { BASEURL } from '../config/api';
import { getSession } from '../services/session';
export default function LiveUpdates() {
  const [connected, setConnected] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    let timer;
    const connect = async () => {
      try {
        const session = getSession();
        if (!session) return;
        const response = await fetch(`${BASEURL}/dashboard/events`, { headers: session.token ? { Authorization: `Bearer ${session.token}` } : {}, credentials: 'same-origin', signal: controller.signal, cache: 'no-store' });
        if (!response.ok || !response.headers.get('content-type')?.includes('text/event-stream')) throw new Error('Stream unavailable');
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        setConnected(true);
        window.dispatchEvent(new Event('dashboard:data-changed'));
        while (!controller.signal.aborted) {
          const { value, done } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const messages = buffer.split('\n\n');
          buffer = messages.pop();
          if (messages.some(event => event.includes('data: changed'))) window.dispatchEvent(new Event('dashboard:data-changed'));
        }
      } catch { /* Polling continues while reconnecting. */ }
      if (!controller.signal.aborted) { setConnected(false); timer = setTimeout(connect, 5000); }
    };
    connect();
    return () => { controller.abort(); clearTimeout(timer); };
  }, []);
  return <Tag color={connected ? 'blue' : 'default'}>{connected ? 'Live updates' : 'Auto-refresh · 15s'}</Tag>;
}
